import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';

import { CoreConfigService } from "@core/services/config.service";
import { TokenOAuth } from 'app/auth/models/token-oauth';
import { User } from 'app/auth/models/user';
import { UserOAuth } from 'app/auth/models/user-oauth';
import { AuthenticationService } from 'app/auth/service';
import { AdminService } from 'app/auth/service/admin.service';

export let userToMenu;

@Component({
  selector: 'app-return-oauth',
  templateUrl: './return-oauth.component.html',
  styleUrls: ['./return-oauth.component.scss']
})

export class ReturnOauthComponent implements OnInit {

  inProcess: boolean = true;
  inLoadProfile: boolean = false;
  accessDenied: boolean = false;

  userOAuth: UserOAuth = null;
  tokenOAuth: TokenOAuth = null;
  teste;
  showChoose: boolean = false;
  showError: boolean = false;
  errorMessage: string = "";
  imageCard1 = ""
  imageCard2 = ""
  constructor(
    private _coreConfigService: CoreConfigService,
    private _router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService) { 
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  ngOnInit(): void {
   
    this.route.queryParams
    .subscribe(params => {
      let code = params.code;
      this.authenticationService
      .authenticate(code)
      .subscribe(
        data => {
          this.inProcess = false;
          this.userOAuth = new UserOAuth(data.userOAuthResponse);
          this.tokenOAuth = new TokenOAuth(data.tokenOAuthResponse);
          this.authenticationService.setUserOAuth(this.userOAuth);
          this.authenticationService.setTokenOAuth(this.tokenOAuth);
          this.processProfile();
        },
       (e: HttpErrorResponse) => {
          this.inProcess = false;
          this.errorMessage = "Não foi possível validar o seu acesso na ferramenta.";
          this.showError = true;
        }
      )
    });
  }

  processProfile() {
    this.inLoadProfile = true;
    this.authenticationService
    .getProfile()
    .subscribe(
      data => {
        this.inLoadProfile = false;
        let user = null;
        let usuario = data.usuario;
        
        if (usuario != null) {
          user = new User(usuario);
          user.superAdmin = false;
        } else {
          user = new User(data.administrador);
          user.admin = false;
          user.superAdmin = true;
          user.empresaAcessoAgendamentoReunioes = true;
          user.empresaAcessoInformacoesCompliance = true;
          user.empresaAcessoPoliticasCompliance = true;
          user.empresaAcessoTreinamentos = true;
        }
        userToMenu = user;
        this.authenticationService.registerUser(user);

        if (user.superAdmin == true) {
          this._router.navigate(['/admin/painel-administrativo']);
        } else {
          if (user.admin == true) {
            this.showChoose = true;
          } else {
            this._router.navigate(['/portal/home']);
          }
        }
      },
      (e: HttpErrorResponse) => {
        this.inLoadProfile = false;
        if ([401, 403].indexOf(e.status) !== -1) {
          this.errorMessage = "Você não está autorizado a entrar nessa ferramenta!";
          this.accessDenied = true;
        } else {
          this.errorMessage = "Não foi possível carregar o seu perfil de acesso.";
        }
        this.showError = true;
      }
    )
  }

}
